<app-section-banner [title]="'T\u0026C'" [backgroundImage]="'assets/img/terms&conditions.jpg' | imageConverter">
</app-section-banner>


<section id="terminos-anchor" class="flex items-center justify-center min-h-screen  px-4 sm:px-6 lg:px-8">
  <div class="text-center text-[#020042] max-w-lg lg:max-w-2xl xl:max-w-3xl mx-auto">

    <h1 id="terminos-anchor" class="text-2xl sm:text-3xl font-bold mb-6"> {{ 'terms.title' | translate }}
    </h1>

    <p class="text-sm sm:text-base font-extralight leading-loose mb-8">
      {{ 'terms.description' | translate }}
    </p>

    <a [routerLink]="['/contact']" [queryParams]="{ newsletter: true }" role="button" tabindex="0"
      aria-label="Volver a la página de suscripción" class="inline-block px-6 py-3 bg-[#5173EF] text-[#F2F4FE] font-extralight text-sm sm:text-base tracking-wide rounded
         hover:bg-[#ffffff] hover:text-[#020042] transition-all">
      {{ 'terms.back_to_newsletter' | translate }}
    </a>
  </div>
</section>